import { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { 
  FaChartPie, 
  FaPenSquare, 
  FaHistory, 
  FaComments, 
  FaAngleDoubleLeft, 
  FaAngleDoubleRight,
  FaTimes 
} from 'react-icons/fa';

const UserSidebar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobileState = window.innerWidth <= 768;
      setIsMobile(mobileState);
      if (!mobileState) {
        setShowMobileMenu(false); 
        setCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleOverlayClick = () => {
    setShowMobileMenu(false);
  };

  return (
    <>
      <style>{`
        .user-sidebar-container {
            font-family: "Poppins", sans-serif;
        }
        .mobile-toggle-btn {
            display: none;
            position: fixed;
            top: 90px;
            left: 0;
            z-index: 1100;
            background: #7eb4bd;
            border: none;
            padding: 10px 15px 10px 10px;
            border-radius: 0 50px 50px 0;
            box-shadow: 2px 2px 5px rgba(0,0,0,0.15);
            color: #fff;
            font-size: 1.2rem;
            cursor: pointer;
            transition: all 0.3s ease;
        }
        .mobile-toggle-btn:hover {
            background: #5a96a0;
            padding-left: 15px;
        }
        .user-sidebar {
            min-height: 100vh;
            width: 250px;
            padding-top: 20px;
            background-color: #f5f7fa;
            color: #333;
            transition: width 0.3s ease, transform 0.3s ease;
            overflow: hidden;
            font-family: "Poppins", sans-serif;
            border-right: 1px solid #e0e0e0;
            box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
            position: relative;
            z-index: 1000;
        }
        .user-sidebar.collapsed {
            width: 70px;
        }
        .user-sidebar .sidebar-header {
            padding: 0 1rem 1rem 1rem;
            margin-bottom: 1rem;
            font-size: 1.1rem;
            font-weight: 600;
            color: #444;
            border-bottom: 1px solid #e0e0e0;
            text-align: center;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
        }
        .user-sidebar .collapsed-icon {
            font-size: 1.4rem;
            color: #7eb4bd;
        }
        .user-sidebar .nav-link {
            color: #555;
            padding: 12px 20px;
            display: flex;
            align-items: center;
            gap: 15px;
            font-weight: 500;
            transition: background 0.2s, color 0.2s;
            border-radius: 6px;
            margin: 4px 8px;
            white-space: nowrap;
        }
        .user-sidebar .nav-link svg {
            font-size: 1.3rem;
            min-width: 24px;
            color: #7eb4bd;
            transition: color 0.2s ease;
        }
        .user-sidebar .nav-link:hover {
            background-color: #e8edf3;
            color: #000;
        }
        .user-sidebar .nav-item.active .nav-link {
            background-color: #0d6efd;
            color: #fff;
        }
        .user-sidebar.collapsed .nav-link span {
            opacity: 0;
            visibility: hidden;
            width: 0;
        }
        .user-sidebar.collapsed .nav-link {
            justify-content: center;
            padding: 12px 0;
        }
        .user-sidebar.collapsed .nav-link svg {
            margin-right: 0;
            font-size: 1.5rem;
        }
        .mobile-overlay {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            z-index: 900;
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        @media (max-width: 768px) {
            .mobile-toggle-btn {
                display: block;
            }
            .user-sidebar {
                position: fixed;
                top: 0;
                left: 0;
                height: 100vh;
                transform: translateX(-100%);
                width: 250px !important;
            }
            .user-sidebar.mobile-open {
                transform: translateX(0);
            }
            .user-sidebar .sidebar-header {
                justify-content: space-between;
                padding-left: 20px;
            }
            .user-sidebar .close-btn {
                cursor: pointer;
                color: #7eb4bd;
                font-size: 1.2rem;
            }
            .mobile-overlay.show {
                display: block;
                opacity: 1;
            }
            .user-sidebar.collapsed .nav-link span {
                opacity: 1;
                visibility: visible;
                width: auto;
            }
            .user-sidebar.collapsed .nav-link {
                justify-content: flex-start;
            }
        }
      `}</style>

      {isMobile && (
        <>
          <button className="mobile-toggle-btn" onClick={toggleMobileMenu}>
            <FaAngleDoubleRight />
          </button>
          <div 
            className={`mobile-overlay ${showMobileMenu ? 'show' : ''}`} 
            onClick={handleOverlayClick}
          />
        </>
      )}

      <Nav
        className={`flex-column user-sidebar ${
          isMobile 
            ? (showMobileMenu ? 'mobile-open' : '') 
            : (collapsed ? 'collapsed' : '')
        }`}
        onMouseEnter={() => !isMobile && setCollapsed(false)}
        onMouseLeave={() => !isMobile && setCollapsed(true)}
      >
        <div className="sidebar-header">
          {!collapsed || isMobile ? <h5>Menu Pelapor</h5> : <FaAngleDoubleLeft className="collapsed-icon" />}
          
          {isMobile && (
            <FaTimes className="close-btn" onClick={() => setShowMobileMenu(false)} />
          )}
        </div>

        <LinkContainer to="/dashboard/grafik">
          <Nav.Link onClick={() => isMobile && setShowMobileMenu(false)}>
            <FaChartPie />
            <span>Ringkasan Pengaduan</span>
          </Nav.Link>
        </LinkContainer>

        <LinkContainer to="/dashboard/buat-laporan">
          <Nav.Link onClick={() => isMobile && setShowMobileMenu(false)}>
            <FaPenSquare />
            <span>Rekam Pengaduan</span>
          </Nav.Link>
        </LinkContainer>

        <LinkContainer to="/dashboard/tanya-sipuma">
          <Nav.Link onClick={() => isMobile && setShowMobileMenu(false)}>
            <FaComments />
            <span>Layanan AI</span>
          </Nav.Link>
        </LinkContainer>
      </Nav>
    </>
  );
};

export default UserSidebar;